module.exports = __webpack_public_path__ + "img/dis-quyue.f2174b6e.svg";